import { render, staticRenderFns } from "./PrivatePunch.vue?vue&type=template&id=3a0c912f&scoped=true"
import script from "./PrivatePunch.vue?vue&type=script&lang=js"
export * from "./PrivatePunch.vue?vue&type=script&lang=js"
import style0 from "./PrivatePunch.vue?vue&type=style&index=0&id=3a0c912f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0c912f",
  null
  
)

export default component.exports